module.exports = __webpack_public_path__ + "static/media/fathersdayThumb.760fc478.jpeg";